import config from './config.dev.json';
import prodConfig from './config.prod.json';
import stgConfig from './config.stg.json';

let environment: typeof config.dev;

switch (process.env.REACT_APP_ENV) {
  case 'stg':
    environment = stgConfig.stg;
    break;
  case 'prod':
    environment = prodConfig.prod;
    break;
  default:
    environment = process.env.NODE_ENV === 'development' ? config.dev : config.ci;
    break;
}

export default environment;
